export default "__VITE_ASSET__CpTNCIad__"